import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { ECommerce, Wishlist } from "../../../../constants";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";
import WishlistProducts from "./WishlistProducts";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";

// This component serves as the main container for the wishlist page, rendering the wishlist products.
const WishlistContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Wishlist} parent={ECommerce} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={Wishlist} />
              <CardBody>
                <WishlistProducts />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default WishlistContainer;